import './App.css';
import { Redirect, Route, Switch } from 'react-router-dom';
import { HOME_PATH, SIGN_IN_PATH, ADMIN_PATH } from 'routes/constants.routes';

import SignIn from 'pages/SignIn/SignIn';
import PrivateRoute from 'routes/PrivateRoute';
import useAuthStore from 'context/AuthStore/useAuthStore';
import Home from 'pages/Home/Home';
import AdminPage from 'pages/AdminPage/AdminPage';
import NoMatch from 'pages/NoMatch/NoMatch';
import { useRoutes } from 'hooks';

function App() {
  const { authStore } = useAuthStore();
  const lastVisit = useRoutes();
  return (
    <Switch>
      <PrivateRoute exact path={HOME_PATH} component={Home} />
      <PrivateRoute exact path={[`${ADMIN_PATH}/:id?`]} component={AdminPage} />
      <PrivateRoute exact path={`${ADMIN_PATH}`} component={AdminPage} />
      <Route path={SIGN_IN_PATH} component={SignIn} />
      <Route exact path='/'>
        {authStore.isLoggedIn ? <Redirect to={HOME_PATH} /> : <Redirect to={SIGN_IN_PATH} />}
      </Route>
      <Route path='*'>
        <NoMatch />
      </Route>
    </Switch>
  );
}

export default App;
